// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretRightFilledSvg from "@ant-design/icons-svg/es/asn/CaretRightFilled";
import AntdIcon from '../components/AntdIcon';

var CaretRightFilled = function CaretRightFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretRightFilledSvg
  }));
};

CaretRightFilled.displayName = 'CaretRightFilled';
export default React.forwardRef(CaretRightFilled);